<template>
    <div v-show="show" class="bg">
        <div class="box-container">
            <div class="title">
                <img src="./assets/alertIcon.png" alt="">
                <p>您未绑定平台账号</p>
            </div>

            <div class="content">
                <span>请前往个人设置</span>
                <!-- <div class="addCount">
                    <img src="./assets/addIcon.png" alt="">
                    <p>添加账号</p>
                </div> -->
                <div @click="re" class="reCount">
                    重新绑定
                </div>
                <span>或联系系统管理员添加平台</span>
            </div>

            <div class="btns">
                <p @click="confirm" class="btn on">确定</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                config: {},
                call: null,
                show: true
            }
        },
        methods: {
            re() {
                this.$BPlus(this.config).then(e => {
                    if(e){
                        this.close()
                    }
                })
            },
            open(config,call) {
                this.config = config;
                this.call = call;
                this.show = true
            },
            close() {
                this.call(false)
                this.show = false
            },
            confirm() {
                // this.call(true)
                this.close()
            }
        }
    }
</script>

<style lang="less" scoped>
@import "../../assets/css/global.less";
.bg {
    position: relative;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(50, 59, 75, 0.3);
    border-radius: 2px;
    backdrop-filter: blur(1.6px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1008;

    .box-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 472px;
        min-height: 170px;
        padding: 32px 32px 24px;
        background: #F9F9F9;
        border-radius: 4px;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
        box-sizing: border-box;

        .title {
            display: flex;
            flex-direction: row;
            align-items: center;

            img {
                width: 22px;
                height: 22px;
                margin-right: 16px;
            }

            p {
                font-size: 16px;
                font-weight: bold;
                color: #323B4B;
                line-height: 24px;
            }
        }

        .content {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            padding-left: 38px;
            box-sizing: border-box;
            margin-top: 12px;
            font-size: 14px;
            line-height: 22px;
            color: #666666;
            margin-bottom: 24px;

            .addCount {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 88px;
                height: 20px;
                background: rgba(65, 180, 140, 0.15);
                border-radius: 2px;
                border: 1px solid rgba(65, 180, 140, 0.4);
                box-sizing: border-box;
                user-select: none;
                cursor: pointer;
                margin: 0 4px;

                img {
                    width: 11px;
                    height: 11px;
                    margin-right: 3px;
                }

                p {
                    font-size: 12px;
                    color: #41B48C;
                    font-weight: bold;
                    line-height: 20px;
                }
            }

            .reCount {
                width: 71px;
                height: 20px;
                background: #FF555A;
                border-radius: 2px;
                font-size: 12px;
                line-height: 20px;
                color: #FFFFFF;
                text-align: center;
                user-select: none;
                cursor: pointer;
                margin: 0 4px;
            }
        }

        .btns {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;

            .btn {
                width: 65px;
                height: 32px;
                background: #B9C3C3;
                font-size: 14px;
                font-weight: bold;
                color: #FFFFFF;
                line-height: 32px;
                border-radius: 4px;
                text-align: center;
                user-select: none;
                cursor: pointer;

                &.on {
                    background: #41B48C;
                    margin-right: 8px;
                }
            }
        }
    }
}
</style>